<template>
  <div id="StepWizardSegment" class="text-left">
    <Loading
      v-show="loading"
      :text="'Importando Conteúdo'"
      :progressBar="true"
    ></Loading>
    <div class="title-area">
      <h4>
        Muito bem!
        <br />O que você faz?
      </h4>
      <p>Escolha a categoria que melhor descreve o que você faz</p>
    </div>
    <div class="input-area">
      <label for="inputSegment">Área de atuação</label>
      <div v-if="this.$store.state.application.class == 'epics'">
        <span
          @click="handleSegment(item), (showInput = false)"
          class="span--subsegment"
          v-for="item in segmentsEpics"
          :key="item.description"
          :class="[query == item.description ? 'item--active' : '']"
        >
          {{ item.description }}
        </span>
        <span
          @click="(query = ''), (choseOne = false), (showInput = true)"
          class="cursor-pointer"
        >
          + outro
        </span>
      </div>
      <input
        v-if="showInput || this.$store.state.application.class !== 'epics'"
        type="text"
        v-model="query"
        name="inputSegment"
        id="inputSegment"
        class="form-control mt-3"
        @keyup="matchQuery"
        @blur="checkQuery"
        placeholder="Digite para pesquisar"
      />
      <div class="w-100 pt-3" v-if="!choseOne">
        <p class="mb-1" v-for="item in listFilter" :key="item.id">
          <span class="item--segment" @click="handleSegment(item)">{{
            item.description
          }}</span>
        </p>
      </div>
      <div class="mt-4" v-else>
        <label class="d-block">Fale mais detalhes pra gente!</label>
        <span class="add--list--button" @click="showModal = true"></span>
        <span
          @click="handleSubsegments(subItem)"
          class="span--subsegment"
          v-for="subItem in getSubsegments"
          :key="subItem.description"
          :class="[checkSelected(subItem) ? 'item--active' : '']"
        >
          {{ subItem.description }}
        </span>
      </div>
      <b-modal centered hide-footer v-model="showModal" title="Adicionar">
        <div class="row">
          <div class="col-12">
            <input
              ref="focusThis"
              id="newSubsegment"
              v-model="newSubsegment"
              type="text"
              class="form-control"
              placeholder="Digite a nova Categoria"
              @keyup.enter="addNewSubsegment"
            />
          </div>
          <div class="col-12 text-right mt-2">
            <button @click="addNewSubsegment()" class="btn btn-primario">
              Adicionar
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";
export default {
  name: "StepWizardSegment",
  components: {
    Loading,
  },
  data() {
    return {
      loading: true,
      sixtySeconds: 60000,
      segments: [],
      query: "",
      listFilter: [],
      choseOne: false,
      showModal: false,
      newSubsegment: "",
      segmentsEpics: [
        { description: "Fotografia" },
        { description: "Vídeo" },
        { description: "Foto e Vídeo" },
        { description: "Design" },
      ],
      showInput: false,
    };
  },
  beforeCreate() {
    this.$store.dispatch("GET_SEGMENTS");
  },
  mounted() {
    this.$emit("updateStep");
    this.$store.dispatch("WIZARD_BOTTOM_BUTTONS", [true]);
    this.segments = this.$store.state.wizard.segments;
    this.query = this.$store.state.wizard.dataSite.segment;
    if (this.query) {
      this.choseOne = true;
    }
    this.$store.dispatch("WIZARD_SHOW_SKIP", [false]);
    if (
      this.$route.params.buttonJump === "jump" ||
      this.$route.params.buttonJump === undefined
    ) {
      this.loading = false;
    } else {
      setTimeout(() => {
        this.loading = false;
      }, this.sixtySeconds);
    }
  },
  methods: {
    checkQuery() {
      setTimeout(() => {
        let check = this.$store.state.wizard.segments.some(
          (element) => element.description == this.query
        );
        if (!check) {
          this.$store.dispatch("WIZARD_UPDATE_SEGMENT", [this.query]);
          this.$store.dispatch("PUSH_ABOUT_SOCIAL");
        }
      }, 500);
    },
    addNewSubsegment() {
      this.$store.dispatch("WIZARD_CUSTON_SUBSEGMENT", [this.newSubsegment]);
      this.showModal = false;
      this.newSubsegment = "";
    },
    handleSegment(item) {
      //Função de selecionar o segmento ao digitar no campo de pesquisa
      let itemSelected = this.$store.state.wizard.segments.find(
        (segment) => segment.description == item.description
      );
      let steps = itemSelected.steps.filter((element) => element.status == 1);
      steps = steps.map((step) => ({ ...step, dirty: false }));
      this.$store.dispatch("WIZARD_UPDATE_COMPONENTS", [steps]);
      this.$store.dispatch("WIZARD_UPDATE_SUBSEGMENTS", [
        itemSelected.subsegments,
      ]);
      this.choseOne = true;
      this.query = item.description;
      this.$store.dispatch("WIZARD_UPDATE_SEGMENT", [item.description]);
      this.$store.dispatch("UPDATE_ABOUT_LIST", [itemSelected.about]);
    },
    matchQuery() {
      this.choseOne = false;
      if (this.query.length >= 2) {
        this.listFilter = this.listSegments();
      } else {
        this.listFilter = [];
      }
    },
    listSegments() {
      let captalizeQuery =
        this.query.charAt(0).toUpperCase() + this.query.slice(1);
      if (this.query.length > 0) {
        return this.$store.state.wizard.segments
          .filter(
            (segment) =>
              segment.search.filter(
                (item) => item.description.indexOf(captalizeQuery) !== -1
              ).length
          )
          .map((segment) => ({
            description: segment.description,
          }));
      } else {
        return this.$store.state.wizard.segments;
      }
    },
    handleSubsegments(item) {
      let selectedSubsegments =
        this.$store.state.wizard.dataSite.selectedSubsegments;
      let findSubsegment =
        this.$store.state.wizard.dataSite.selectedSubsegments.findIndex(
          (selected) => selected.description == item.description
        );
      if (findSubsegment < 0) {
        this.$store.dispatch("ADD_SUBSEGMENT", [item]);
      } else {
        this.$store.dispatch("REMOVE_SUBSEGMENT", [findSubsegment]);
      }
    },
    checkSelected(item) {
      let selectedSubsegments =
        this.$store.state.wizard.dataSite.selectedSubsegments;
      let findSubsegment =
        this.$store.state.wizard.dataSite.selectedSubsegments.findIndex(
          (selected) => selected.description == item.description
        );
      if (findSubsegment < 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    getSubsegments() {
      return this.$store.state.wizard.subsegments;
    },
  },
  watch: {
    query() {
      if (this.query.length >= 2) {
        this.$store.dispatch("WIZARD_BLOCK_NEXT", [false]);
      } else {
        this.$store.dispatch("WIZARD_BLOCK_NEXT", [true]);
      }
    },
  },
  destroyed() {
    this.$store.dispatch("PAGES_CREATE_CARDS");
  },
};
</script>

<style>
.item--segment {
  cursor: pointer;
}
.add--list--button {
  color: #fff;
  background-color: var(--main-color);
  width: 32px;
  height: 32px;
  display: inline-block;
  margin: 10px 10px 0 0;
  border-radius: 50%;
  cursor: pointer;
}
.add--list--button::after {
  content: "+";
  font-weight: 700;
  font-size: 21px;
  position: relative;
  left: calc(50% - 6px);
}
.span--subsegment {
  background-color: #f8f8f8;
  color: #9a9a9a;
  height: 32px;
  padding: 2px 24px;
  border-radius: 20px;
  display: inline-block;
  cursor: pointer;
  margin: 10px 10px 0 0;
  border: 1px solid transparent;
}
.item--active {
  border: 1px solid var(--main-color);
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/StepWizardSegments.vue